import React from 'react';
import {orderBy as _orderBy} from 'lodash';

export const findById = (arr, id) => arr.find(item => parseInt(item.id) === id);

export const parseReferences = (output_references) => {
    if (!Array.isArray(output_references) || 0 === output_references.length) {
        return '';
    }

    const sortedReferences = _orderBy(output_references, ['output_reference'], ['asc']);

    return (
        <div>
            {sortedReferences.map((ref, index) => (
                <div key={index}>
                    {ref.output_reference}
                    {ref.description ? ` (${ref.description})` : ''}
                </div>
            ))}
        </div>
    );
};

export const parseExcelReferences = (output_references) => {
    if (0 === output_references.length) {
        return '';
    }

    return output_references
        .map(ref => ref.output_reference + (ref.description ? ` (${ref.description})` : ''))
        .join(', ');
};
